import fetch from 'cross-fetch';

class ContentApi {
    static init(lang) {
        return fetch(`/api/public/content/${lang}/home`).then(response => {
            return response.json();
        }).catch(error => {
            return error;
        });
    }
}
export default ContentApi;


// WEBPACK FOOTER //
// ./assets/src/js/api/ContentApi.js